export const MAX_DESCRIPTION_CHARS = 1000
